import { authorizeGetRequest } from "api";
import { IPaginatedResponse } from "models";
import { IReferral } from "models/referral";

export const referralsApi = (page: number, perPage: number, search: string) => {
  return authorizeGetRequest<IPaginatedResponse<IReferral>>(
    `referrals?page=${page}&per_page=${perPage}&query=${search}`
  );
};
